import {
  Description,
  Divider,
  Frame,
  MiddleTitle,
  SubTitle,
} from '../components/common'

import IMGSlackDesktop from '../images/slack/slack-desktop.jpg'
import IMGSlackStep1 from '../images/slack/slack-step1.svg'
import IMGSlackStep2 from '../images/slack/slack-step2.svg'
import IMGSlackStep3 from '../images/slack/slack-step3.png'
import IMGSlackTitle from '../images/slack/slack-integration.svg'
import Layout from '../components/layout'
import React from 'react'
import SEO from '../components/seo'
import { gaEvent } from '../modules/ga'
import { useLocation } from '@reach/router'

const StepItem = ({ step, title, image }) => (
  <div className='flex flex-col lg:flex-row items-start justify-items-start lg:h-48 space-y-3 w-full'>
    <div className='bg-blue-600 w-20 h-20 rounded-full text-gray-50 text-bold text-5xl text-center align-center p-3'>
      {step}
    </div>
    <div className='w-0 lg:w-10' />
    <div className='text-left lg:w-96'>
      <Description>{title}</Description>
    </div>
    <div className='lg:w-10' />
    <div className='flex flex-col w-52 items-center'>
      <img src={image} />
    </div>
  </div>
)

const SlackButton = () => (
  <a href='https://slack.com/oauth/v2/authorize?client_id=641375666771.1471161437335&scope=channels:history,channels:read,chat:write,commands,files:read,files:write,groups:read,groups:write,im:history,im:write,mpim:write,users.profile:read,users:read,channels:manage&user_scope=channels:write,groups:write,mpim:write,im:write'>
    <img
      alt='Add to Slack'
      height='40'
      width='139'
      src='https://platform.slack-edge.com/img/add_to_slack.png'
      srcSet='https://platform.slack-edge.com/img/add_to_slack.png 1x, https://platform.slack-edge.com/img/add_to_slack@2x.png 2x'
    />
  </a>
)

const Home = () => {
  const location = useLocation()
  if (location.search === '?ref=producthunt') {
    gaEvent('onboarding', 'landing', 'producthunt')
  }

  return (
    <Layout>
      <SEO title='Strum - Collaborative canvas for content-base meeting' />
      {/* <FirstSection /> */}

      {/* Slack */}
      <Frame>
        <img
          id='slack'
          src={IMGSlackTitle}
          className='w-96 lg:w-4/12 py-3 lg:py-12'
        />
        <MiddleTitle>
          ‘Strum’ through files within your Slack Channel! (Beta)
        </MiddleTitle>
        <SubTitle>
          Simply install our plugin to your current communication platform
        </SubTitle>
        <div className='max-w-screen-xl'>
          <img src={IMGSlackDesktop} />
        </div>
      </Frame>

      <Frame>
        <MiddleTitle>Simple Steps to Strum in Slack</MiddleTitle>

        <div className='flex flex-col items-start'>
          <StepItem
            step={1}
            image={IMGSlackStep1}
            title='Drop files to your Slack Channel'
          />
          <StepItem
            step={2}
            image={IMGSlackStep2}
            title='Command or Type ‘/strum’ on chat'
          />
          <StepItem step={3} image={IMGSlackStep3} title='Start Strumming!' />
        </div>

        <SlackButton />
        {/* <Information>Add Strum app to Slack for beta-testing. </Information> */}
      </Frame>

      <div className='flex flex-col items-center'>
        <Divider />
      </div>

    </Layout>
  )
}

export default Home
